import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const el = document.createElement("textarea");
      el.value = text;
      el.style.position = "fixed";
      el.style.opacity = "0";
      document.body.appendChild(el);
      el.select();
      const ok = document.execCommand("copy");
      el.remove();
      return ok;
    } catch {
      return false;
    }
  }
};

export const downloadCsv = async (path, params, filename) => {
  const r = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(new Blob([r.data], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const rp = (n) => {
  const v = Math.round(Number(n) || 0);
  return "Rp" + v.toLocaleString("de-DE");
};

export const fmtDate = (d, lang = "en") => {
  if (!d) return "-";
  const dt = new Date(d.length <= 10 ? `${d}T00:00:00` : d);
  return dt.toLocaleDateString(lang === "id" ? "id-ID" : "en-GB", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });
};

export const fmtTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const BOOKING_STATUSES = ["Inquiry", "Waiting Confirmation", "Confirmed", "Waiting Payment", "DP Paid",
  "Paid", "Preparing", "Out for Delivery", "Rented / Playing", "Waiting for Pickup", "Returned", "Inspection",
  "Completed", "Cancelled"];

export const PAYMENT_STATUSES = ["Unpaid", "DP Paid", "Partially Paid", "Paid", "Refunded"];
export const DEPOSIT_STATUSES = ["Not Paid", "Paid", "Pending Return", "Fully Returned", "Partially Deducted", "Fully Deducted"];
export const UNIT_STATUSES = ["Available", "Reserved", "Rented", "Preparing", "Maintenance", "Damaged", "Unavailable", "Retired"];
export const CUSTOMER_TYPES = ["Personal", "Community", "Cafe", "Event", "Corporate", "Other"];
export const OVERRIDE_REASONS = ["Community Partnership", "Cafe Partnership", "Corporate", "VIP", "Friend / Family",
  "Event Collaboration", "Compensation", "Special Promotion", "Owner Approval", "Other"];
export const DISCOUNT_REASONS = ["Promotion", "Returning Customer", "VIP", "Community", "Cafe Partnership",
  "Corporate", "Event", "Compensation", "Friend / Family", "Owner Approval", "Other"];
export const CHECKLIST_ITEMS = ["Machine Returned", "144 Mahjong Tiles Complete", "Mahjong Rulers Complete",
  "Powerbank Returned", "Charging Cable Returned", "Carrying Bag Returned", "Machine Working",
  "Carpet Good Condition", "No Liquid Damage", "No Physical Damage", "Unit Clean", "Accessories Complete"];

export const statusColor = (s) => {
  const map = {
    "Waiting Confirmation": "bg-amber-100 text-amber-800 border-amber-200",
    "Confirmed": "bg-emerald-100 text-emerald-800 border-emerald-200",
    "Waiting Payment": "bg-orange-100 text-orange-800 border-orange-200",
    "Paid": "bg-emerald-100 text-emerald-800 border-emerald-200",
    "DP Paid": "bg-lime-100 text-lime-800 border-lime-200",
    "Rented / Playing": "bg-blue-100 text-blue-800 border-blue-200",
    "Out for Delivery": "bg-indigo-100 text-indigo-800 border-indigo-200",
    "Preparing": "bg-sky-100 text-sky-800 border-sky-200",
    "Waiting for Pickup": "bg-purple-100 text-purple-800 border-purple-200",
    "Completed": "bg-neutral-200 text-neutral-700 border-neutral-300",
    "Cancelled": "bg-red-100 text-red-700 border-red-200",
  };
  return map[s] || "bg-neutral-100 text-neutral-700 border-neutral-200";
};
